import { SortableElement } from "react-sortable-hoc";
import { FolderBookmark } from "./FolderBookmark";
import { LinkBookmark } from "./LinkBookmark";
import type { Bookmark } from "./helpers/bookmark_helper";
import { isBookmarkFolder } from "./helpers/bookmark_helper";

export interface SortableItemProps {
  bookmark: Bookmark;
}

export const SortableItem = SortableElement(
  ({ bookmark }: SortableItemProps) => {
    const isFolder = isBookmarkFolder(bookmark);

    return (
      <div className="bg-primary hover:text-dark hover:bg-tertiary text-default z-20 flex rounded-md transition-colors">
        {isFolder ? (
          <FolderBookmark bookmark={bookmark} />
        ) : (
          <LinkBookmark bookmark={bookmark} />
        )}
      </div>
    );
  },
);
